export const computeInterval = (start: number, end: number) =>
  Math.round(Math.abs(end - start));
